import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { setPromptName } from '../../../../store/summaryTest/slice';
import Select, { SelectOption } from '../../../../components/UI/Select';
import { Heading } from '../../../../components/Typography';
import { SummaryType } from '../../../../store/research/types';

const promptNameOptions: SelectOption[] = [
  { value: 'mini_biz_context', label: 'Mini Business Context' },
  { value: 'risks', label: 'Risks' },
  { value: 'biz_description', label: 'Business Description' },
  { value: 'investment_thesis', label: 'Investment Thesis' },
  { value: 'competitors', label: 'Competitors' },
];

const PromptNameSelector: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const promptName = useSelector((state: RootState) => state.summaryTest.promptName);

  const handlePromptNameChange = (value: string | undefined) => {
    dispatch(setPromptName(value as SummaryType | undefined));
  };

  return (
    <div>
      <Heading level={2}>3. Select Prompt</Heading>
      <Select
        options={promptNameOptions}
        value={promptName}
        onChange={handlePromptNameChange}
        fullWidth
        isClearable
        placeholder="Select a prompt..."
      />
    </div>
  );
};

export default PromptNameSelector;
